import { isIframed } from '../isIframed/isIframed';

const TOURBUILDER_WINDOW_NAME = 'TourBuilder';

export const isIframedWithClientLibrary = () => {
  return isIframed() && window.name === TOURBUILDER_WINDOW_NAME;
};
